import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

const Text = styled.p`
  color: ${({theme}) => theme.text.light};
  font-size: ${({theme}) => theme.text.s7};
  line-height: ${({theme}) => `calc(${theme.text.s8} * 1.4)`};
  font-weight: 400;
  text-align: center;
  letter-spacing: 0.5px;
  padding: 1rem;
  margin: 0;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
`;

const TypingAnimation = ({
  string,
  typingSpeed = 70,
}: {
  string: string;
  typingSpeed?: number;
}) => {
  const [text, setText] = useState('');

  useEffect(() => {
    const array = string.split('');
    let timer: NodeJS.Timeout;

    const frameLooper = () => {
      if (array.length > 0) {
        setText(prev => prev + array.shift());
      } else {
        clearTimeout(timer);
        return;
      }
      timer = setTimeout(frameLooper, typingSpeed);
    };

    frameLooper();

    return () => clearTimeout(timer);
  }, []);

  return <Text id="text">{text}</Text>;
};

export default TypingAnimation;
